import React from 'react'
import { useTranslation } from 'react-i18next'
import { memo } from '~/ui/component'
import { Chip, ChipProps } from '~/ui/components'
import { useTheme } from '~/ui/styling'

export interface Props extends Omit<ChipProps, 'icon' | 'backgroundColor' | 'color' | 'children'> {
  isEnrolled:       boolean
  isOnWaitingList:  boolean
  placesLeft:       number | null
}

const BeWizrEnrollmentStatus = memo('BeWizrEnrollmentStatus', (props: Props) => {

  const {isEnrolled, isOnWaitingList, placesLeft, ...rest} = props

  const [t] = useTranslation('bewizr')

  const placesAvailable = placesLeft === null || placesLeft > 0

  const {colors} = useTheme()

  //------
  // Rendering

  function render() {
    const icon  = isOnWaitingList ? 'clock' : isEnrolled ? 'check' : undefined
    const color = isEnrolled || placesAvailable
      ? colors.named.darkGreen : !isOnWaitingList
      ? colors.named.darkRed : undefined
    const backgroundColor = isEnrolled || placesAvailable
      ? colors.named.lightGreen : !isOnWaitingList
      ? colors.named.lightRed : colors.semantic.neutral
    return (
      <Chip
        children={renderCaption()}
        icon={icon}
        backgroundColor={backgroundColor}
        color={color}
        {...rest}
      />
    )
  }

  function renderCaption() {
    if (isEnrolled) {
      return t('enrollment-status.enrolled')
    } else if (isOnWaitingList) {
      return t('enrollment-status.waiting-list')
    } else if (!placesAvailable) {
      return t('enrollment-status.full')
    } else if (placesLeft === null) {
      return t('enrollment-status.places-available')
    } else {
      return t('enrollment-status.places-left', {count: placesLeft})
    }
  }

  return render()

})

export default BeWizrEnrollmentStatus